const Talentcard = (props) => {
  return (
    <div
      className={`bg-contain bg-no-repeat bg-bottom cursor-pointer overflow-hidden ${props.backgroundImageClass}`}
      style={{ backgroundImage: `url(${props.backgroundImage})` }}
      onClick={() => (props.onClick ? props.onClick() : null)}
    >
      <div className={`relative ${props.Talentcardlayout}`}>
        {!!props.image?.trim() && !props.image.includes("null") && (
          <img
            className="w-full h-full object-contain"
            src={props.image}
            alt={props.realName}
          />
        )}
        <div className="absolute lg:bottom-6 xl:bottom-12 xs:left-3 bottom-4 sm:bottom-4 sm:left-4 lg:left-5 xl:left-7 max-w-80">
          <h1 className="text-secondary font-unboundedSemiBold uppercase xs:text-sm sm:text-base line-clamp-2 lg:text-3xl xl:text-4xl distant truncate">
            {props.title}
          </h1>
          <p className="text-secondary font-onestMedium xs:text-xs sm:text-sm lg:text-xl">
            {props.dic}
          </p>
          
          {/* Updated code to extract the property from objects */}
          {props.desiredJobTypes && Array.isArray(props.desiredJobTypes) && props.desiredJobTypes.length > 0 && (
            <p className="text-secondary font-onestMedium xs:text-xs sm:text-sm lg:text-base mt-1">
              {props.desiredJobTypes.map(job => job.name || job.title || job.job_type).join(" • ")}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
export default Talentcard;